import React from 'react';

/**
 * RightSidebar Component
 * Displays contextual information based on current view
 */
const RightSidebar = ({ isCollapsed, content }) => {
  if (isCollapsed) {
    return null;
  }

  return (
    <aside className="hidden w-80 overflow-y-auto border-l border-border bg-background-secondary xl:block xl:w-[280px]">
      <div className="p-6">
        {content}
      </div>
    </aside>
  );
};

export default RightSidebar;
